import { createFileRoute } from "@tanstack/react-router"
import { EditAnnouncementPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/communication/announcements/$announcementUuid/edit"
)({
  component: function EditAnnouncementRoute() {
    const { announcementUuid } = Route.useParams()
    return (
      <AuthorizationGate
        resource={Resource.ANNOUNCEMENT}
        action={Action.UPDATE}
      >
        <EditAnnouncementPage announcementUuid={announcementUuid} />
      </AuthorizationGate>
    )
  },
})
